import { render, staticRenderFns } from "./VoucherRedemption.vue?vue&type=template&id=3b316278&scoped=true"
import script from "./VoucherRedemption.vue?vue&type=script&lang=js"
export * from "./VoucherRedemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b316278",
  null
  
)

export default component.exports